// このファイルは自動生成されています
/**
 *  [2024] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */
/**
 * Lambda: multiorgcasemanageにアクセスするためのドライバーコード
 * 案件ベースのデータのCRUD処理を実施する
 */

import {makeApiCall, createOptions} from '@zettant/commonUtils/comm';
import {awsResources, salt} from '@/awsCodes/resourceParams';
import {getAuthInfo} from '@zettant/awsUtils';
import {ICaseBase, ICaseData, IOrganizationBase, IResponse} from '../interfaces';


/**
 * Lambda: multiorgcasemanageにアクセスするためのドライバ関数
 * @param needIdToken {boolean}
 * @param cmd {string|undefined}
 * @param caseRecord {ICaseBase|undefined}
 * @param orgRecord {IOrganizationBase|undefined}
 * @param organizationId {string|undefined}
 * @param updatedAt {number|undefined}
 * @param records {string|undefined}
 * @param record {ICaseData|undefined}
 * @param overwrite {boolean|undefined}
 * @param filename {string|undefined}
 * @param path {string|undefined}
 * @param media {string|undefined}
 * @param caseId {string|undefined}
 * @return Promise<IResponse>
 * @throw {Error} Throws Error object
 */
export const multiorgcasemanageCall = async (needIdToken: boolean, cmd: string|undefined, caseRecord: ICaseBase|undefined, orgRecord: IOrganizationBase|undefined, organizationId: string|undefined, updatedAt: number|undefined, records: string|undefined, record: ICaseData|undefined, overwrite: boolean|undefined, filename: string|undefined, path: string|undefined, media: string|undefined, caseId: string|undefined): Promise<IResponse> => {
  // ----PREPARATION-OF-METHOD----
  // ----END-OF-PREPARATION----

  let idToken: string|undefined;
  if (needIdToken) {
    const res: any = await getAuthInfo();
    if (!res) throw new Error('refreshToken expired');
    idToken = res.idToken;
  }

  const restPath = awsResources.baseUrl[`multiorgcasemain${salt}`];
  const makeApiCallOptions = createOptions(idToken, `${restPath}/data`, {}, {cmd, caseRecord, orgRecord, organizationId, updatedAt, records, record, overwrite, filename, path, media, caseId});
  const {response}: any = await makeApiCall(makeApiCallOptions)
    .then((r: any) => ({response: r}))
    .catch((e) => ({error: e}));
  return response;
};


